import { render } from "./Typewriter.vue?vue&type=template&id=596fee5d&scoped=true"
import script from "./Typewriter.vue?vue&type=script&lang=js"
export * from "./Typewriter.vue?vue&type=script&lang=js"

import "./Typewriter.vue?vue&type=style&index=0&id=596fee5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596fee5d"]])

export default __exports__